import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.71468 0.878114C7.80449 0.601721 8.19551 0.601722 8.28532 0.878115L9.72876 5.32057C9.76892 5.44418 9.88411 5.52786 10.0141 5.52786H14.6851C14.9758 5.52786 15.0966 5.89975 14.8615 6.07057L11.0825 8.81616C10.9774 8.89255 10.9334 9.02796 10.9735 9.15157L12.417 13.594C12.5068 13.8704 12.1904 14.1003 11.9553 13.9294L8.17634 11.1838C8.07119 11.1074 7.92881 11.1075 7.82366 11.1838L4.04469 13.9294C3.80957 14.1003 3.49323 13.8704 3.58303 13.594L5.02648 9.15157C5.06664 9.02796 5.02264 8.89255 4.91749 8.81616L1.13852 6.07057C0.903402 5.89975 1.02424 5.52786 1.31485 5.52786H5.98593C6.11589 5.52786 6.23108 5.44418 6.27124 5.32057L7.71468 0.878114Z" })
});
export default SvgStar;
